import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor() {
    this.applicationEventSubject = new BehaviorSubject<string>('');
    this.applicationEventSubscription = this.applicationEventSubject.asObservable();
  }

  applicationEventSubscription:Observable<string>;
  applicationEventSubject:BehaviorSubject<string>;
  isApplicationBusy:boolean = false;

  showGlobalSpinner():void {
    this.isApplicationBusy = true;
    this.applicationEventSubject.next('SHOWGLOBALSPINNER');
  }

  hideGlobalSpinner():void {
    this.isApplicationBusy = false;
    this.applicationEventSubject.next('HIDEGLOBALSPINNER');
  }

  formatLocalDateTime(utcString: string): string {
    return new Intl.DateTimeFormat(undefined, {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
      .format(new Date(utcString))
      .replace(',', '')
      .toLowerCase();
  }

    formatUTCDate(date: string | Date | undefined): string {
    if (!date) return '';

    // If already a Date object, format via UTC components
    if (date instanceof Date) {
      const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
      const dd = String(date.getUTCDate()).padStart(2, '0');
      const yy = String(date.getUTCFullYear()).slice(-2);
      return `${mm}/${dd}/${yy}`;
    }

    // Handle date-only strings safely
    // Supports: YYYY-MM-DD, YYYY-MM-DDTHH:mm:ssZ, etc
    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return '';

    const [, y, m, d] = match;

    return `${m}/${d}/${y.slice(-2)}`;
  }

  formatScoreToPar(score:number):string {
    if(score < 0)
      return score.toString();
    else if(score > 0)
      return `+${score}`;
    else
      return 'E';
  }

  formatHolesToPlay(holesToPlay:string):string {
    switch(holesToPlay.toUpperCase()) {
      case 'FRONT9':
        return "Front 9";
      case 'BACK9':
        return "Back 9";
      case 'ALL18':
        return 'All 18';
      default:
        return '';
    }
  }
}